import "react-day-picker/lib/style.css";
import {
  RenderWarning,
  RenderActions,
  RenderInput,
  RenderText,
  RenderDateInput,
  RenderWageInput,
  RenderWageFrequency,
} from "../Shared/renderCells";

export default [
  {
    Header: " ", // needs to be a space if you want it blank
    width: 35,
    minWidth: 25,
    Cell: RenderWarning,
  },
  // {
  //   Header: "Determined Wage",
  //   accessor: "determined_wage",
  //   width: 100,
  //   minWidth: 100,
  //   prependValue: "$",
  //   Cell: RenderText,
  // },
  {
    Header: `1. City*`,
    accessor: "appx_b_city",
    Cell: RenderInput,
    charLimit: 35,
    validate: [
      "required",
      {
        maxLength: 35,
        message: "This field cannot be more than 35 characters long.",
      },
    ],
  },
  {
    Header: "2. State*",
    accessor: "appx_b_state_id",
    width: 175,
    minWidth: 100,
    Cell: RenderText,
  },
  {
    Header: "3. Postal Code*",
    accessor: "appx_b_zip",
    width: 100,
    minWidth: 100,
    Cell: RenderText,
  },
  {
    Header: "4. Additional Place of Employment Information",
    accessor: "appx_b_employment_info",
    width: 200,
    minWidth: 200,
    charLimit: 120,
    Cell: RenderInput,
    validate: [
      {
        maxLength: 120,
        message: "This field cannot be more than 120 characters long.",
      },
    ],
  },
  {
    Header: "5. Crew ID",
    accessor: "appx_b_crew_id",
    width: 50,
    minWidth: 50,
    Cell: RenderInput,
    charLimit: 2,
    validate: [
      {
        maxLength: 2,
        message: "This field cannot be more than 2 characters long.",
      },
    ],
  },
  {
    Header: "6. Total Workers",
    accessor: "appx_b_total_workers",
    width: 50,
    minWidth: 50,
    Cell: RenderInput,
    requiredFields: [
      {
        field: "eb2_num_workers",
        message:
          "You must specify the number of workers allowed at each worksite in section E.b.2.",
      },
    ],
    validate: [
      {
        maxValue: "eb2_num_workers",
        message:
          "Total workers must be less than or equal to the number of workers you specified in section E.b.2.",
        needsFieldValues: true,
        extraData: {
          operator: "<=",
          valueOf: "eb2_num_workers",
        },
      },
    ],
    input: { type: "number", min: 0, max: 10000 },
  },
  {
    Header: "7. Begin Date",
    accessor: "appx_b_begin_date",
    Cell: (props) =>
      RenderDateInput({
        beginDateProperty: "eb3_start_date",
        endDateProperty: "eb4_end_date",
        rowBeginDateProperty: "appx_b_begin_date",
        rowEndDateProperty: "appx_b_end_date",
        originalDateSection: "E.b",
        ...props,
      }),
    overflow: "visible",
    validate: [],
  },
  {
    Header: "8. End Date",
    accessor: "appx_b_end_date",
    Cell: (props) =>
      RenderDateInput({
        beginDateProperty: "eb3_start_date",
        endDateProperty: "eb4_end_date",
        rowBeginDateProperty: "appx_b_begin_date",
        rowEndDateProperty: "appx_b_end_date",
        originalDateSection: "E.b",
        ...props,
      }),
    overflow: "visible",
    validate: [],
  },
  {
    Header: "9. Basic Wage Rate From",
    accessor: "appx_b_wage_from",
    Cell: (props) =>
      RenderWageInput({
        newWagePerProperty: "appx_b_wage_freq",
        newWageFromProperty: "appx_b_wage_from",
        newWageToProperty: "appx_b_wage_to",
        ...props,
      }),
  },
  {
    Header: "10. Basic Wage Rate To",
    accessor: "appx_b_wage_to",
    Cell: (props) =>
      RenderWageInput({
        newWagePerProperty: "appx_b_wage_freq",
        newWageFromProperty: "appx_b_wage_from",
        newWageToProperty: "appx_b_wage_to",
        ...props,
      }),
  },
  {
    Header: "11. Per",
    accessor: "appx_b_wage_freq",
    width: 85,
    minWidth: 85,
    Cell: (props) =>
      RenderWageFrequency({
        wageFrequencyArray: [
          "Hourly",
          "Weekly",
          "Biweekly",
          "Monthly",
          "Annual",
          "Piece Rate",
        ],
        ...props,
      }),
  },
  {
    Header: "Actions",
    accessor: "actions",
    width: 100,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: RenderActions,
  },
];
